
import { client, urlFor, getSanityEditLink } from "./sanity-client";
import initScrollAnimations from "./animations";

document.addEventListener("DOMContentLoaded", async () => {
  const leadershipListEl = document.getElementById("leadership-list");
  if (!leadershipListEl) return;

  try {
    const query = `*[_type == "leadership"][0]{
        ...,
        showTeam,
        team[]{
            ...,
            _key
        }
    }`;
    const leadershipDoc = await client.fetch(query);

    if (!leadershipDoc || !leadershipDoc.team || leadershipDoc.team.length === 0) {
      console.error("Leadership data not found");
      return;
    }

    // Team toggle
    if (leadershipDoc.showTeam === false) {
      leadershipListEl.closest('section').style.display = 'none';
    } else {
      renderLeadership(leadershipListEl, leadershipDoc.team, leadershipDoc._id);
      initScrollAnimations();
    }

  } catch (error) {
    console.error("Error fetching leadership data:", error);
  }
});

function renderLeadership(container, leaders, docId) {
  container.innerHTML = leaders.map((leader, index) => createLeaderCard(leader, index, docId)).join('');
}

function createLeaderCard(leader, index, docId) {
  // Alternate padding class based on index (even/odd) to match original layout
  // Original had "add-padding-right" on 1st and 3rd card (index 0, 2) which are col-md-6
  // And index 1, 3 were normal.
  // The last one (Lal) was col-md-12.

  // Let's try to infer layout. 
  // If we just use col-md-6 for everyone, it might flow okay.
  // But the last one was full width.
  // Let's make the last one full width if total count is odd? Or just check specific name?
  // User said "follow the same layout styling with no changes".

  // Total 5 leaders. 
  // 0, 1 -> row 1
  // 2, 3 -> row 2
  // 4 -> row 3 (full width)

  let colClass = "col-12 col-md-6 col-lg-6";
  let paddingClass = "";

  // Last item is full width
  if (index === 4) {
    colClass = "col-12 col-md-12 col-lg-12";
  }

  // Add padding-right to 1st item of each row (even index) EXCEPT the last full-width one
  if (index % 2 === 0 && index !== 4) {
    paddingClass = "add-padding-right";
  }

  // Animation delay
  const delay = (index * 100);

  return `
        <div class="${colClass} d-flex px-sm-0 ${paddingClass}">
          <!-- Card -->
          <div class="card mb-6 shadow-light-lg lift w-100 border-0" data-animate="fade-up" data-delay="${delay}">
            ${docId && leader._key ? getSanityEditLink(docId, 'leadership', `team[_key=="${leader._key}"]`, 'Edit Leader') : ''}
            <!-- Body -->
            <div class="card-body p-6" onclick="window.open('${leader.linkedin}', '_blank');" style="cursor: pointer;">
              <!-- Heading -->
              <div class="row align-items-center mb-4">
                <div class="col">
                  <h4 class="mb-1 fw-bold text-dark">${leader.name}</h4>
                  <p class="text-primary fs-sm mb-0 fw-600">${leader.title}</p>
                </div>
                <div class="col-auto">
                  <div class="btn btn-sm btn-rounded-circle btn-outline-primary">
                    <i class="fe fe-linkedin"></i>
                  </div>
                </div>
              </div>

              <!-- Text -->
              <p class="mb-0 text-muted fs-sm lh-base">
                ${leader.description}
              </p>
            </div>
          </div>
        </div>
    `;
}
